module.exports = __webpack_public_path__ + "static/media/SarahSwitek_15_ThatsAll_6.53e79f3e.mp3";